import enUS from './en_US/growler.en_us.js';

const growlerMessages = {
  enUS,
};

export default growlerMessages;



/** WEBPACK FOOTER **
 ** ./src/locales/growler.locale.js
 **/